<template>
  <Modal
    :show="alertStore.isPopupOpen"
    container-class="atb-w-250"
    body-class="atb-flex atb-flex-row atb-justify-center atb-border-none"
    footer-class="atb-flex atb-flex-row atb-justify-center atb-gap-8"
    @onModalClose="closeButtonEventHandler()"
  >
    <template #header>
      {{ alertStore.popupTitle }}
    </template>
    <template #body>
      <span> {{ alertStore.popupMessage }} </span>
    </template>
    <template #footer>
      <Button @click="okButtonEventHandler()">Ok</Button>
    </template>
  </Modal>
</template>

<script lang="ts" setup>
  import Button from '@atb-ui/eds-vue/src/components/Button.vue';
  import Modal from '@atb-ui/eds-vue/src/components/Modal.vue';
  import { useAlertStore } from '@/app/shared/stores/alert-store';

  interface AlertPopupEvents {
    (_event: 'confirm'): void;
    (_event: 'cancel'): void;
  }

  const emit = defineEmits<AlertPopupEvents>();
  const alertStore = useAlertStore();

  const closeButtonEventHandler = () => {
    emit('cancel');
    alertStore.changePopupVisibility();
  };

  const okButtonEventHandler = () => {
    emit('confirm');
    alertStore.changePopupVisibility();
  };
</script>
